import React, { useState, useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { auth } from "./firebase"; // Adjust path if needed
import { db } from "./firebase";

const useRetailerAuth = () => {
  const [state, setState] = useState({ isLoading: true, isRetailer: false });

  useEffect(() => {
    const verifyRetailer = async () => {
      const sessionData = localStorage.getItem("retailerSession");

      if (!sessionData) {
        setState({ isLoading: false, isRetailer: false });
        return;
      }

      try {
        const parsedSession = JSON.parse(sessionData);
        const retailerDoc = await getDoc(doc(db, "parties", parsedSession.id));

        if (
          retailerDoc.exists() &&
          retailerDoc.data().status === "Active" &&
          retailerDoc.data().type === "Retailer"
        ) {
          // MUTUAL EXCLUSIVITY: Ensure Firebase Admin Auth is signed out if Retailer is active
          if (auth.currentUser) await auth.signOut();
          setState({ isLoading: false, isRetailer: true });
        } else {
          localStorage.removeItem("retailerSession");
          setState({ isLoading: false, isRetailer: false });
        }
      } catch (error) {
        console.error("Retailer verification error:", error);
        setState({ isLoading: false, isRetailer: false });
      }
    };

    verifyRetailer();
  }, []);

  return state;
};

// UI for loading states
const SecurityLoader = ({ text }) => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
      backgroundColor: "#020617",
      color: "#d97706",
      fontFamily: "Inter, sans-serif",
    }}
  >
    {text}
  </div>
);

// 🔒 PROTECTED ROUTE: Only Retailers can enter. Kicks others to login.
export const RequireRetailer = () => {
  const { isLoading, isRetailer } = useRetailerAuth();
  if (isLoading)
    return <SecurityLoader text="Authenticating Retailer Portal..." />;
  return isRetailer ? <Outlet /> : <Navigate to="/retailer/login" replace />;
};

// 🚪 GUEST ROUTE: Only non-retailers can see the login page. Kicks Retailers to dashboard.
export const GuestRetailer = () => {
  const { isLoading, isRetailer } = useRetailerAuth();
  if (isLoading) return <SecurityLoader text="Checking Retailer Session..." />;
  return isRetailer ? <Navigate to="/retailer" replace /> : <Outlet />;
};
